<template>
    <div v-if="! resetting">
        <vue-clip class="Dropzone" :options="vueClipOptions" :on-added-file="addedFile" :on-complete="complete">
            <template slot="clip-uploader-action" class="Utility--height-100">
                <div class="Utility--height-100 uploader-action" v-show="! uploading">
                    <div class="Utility--height-100 dz-message">
                        <a class="Dropzone__button">Upload File</a>
                        <div class="Dropzone__message">{{ message }}</div>
                    </div>
                </div>
            </template>

            <template class="Utility--height-100" slot="clip-uploader-body" scope="props">
                <div class="Utility--height-100" v-show="uploading">
                    <a class="Dropzone__button">Upload File</a>
                    <div v-for="file in props.files">
                        <div :class="messageClasses">
                            <span v-show="! error">{{ file.name }}</span>
                            <span v-show="error">{{ errorMessage }}</span>
                        </div>
                        <div class="Dropzone__progress-bar">
                            <div :class="progressClasses" :style="'width:' + file.progress + '%'"></div>
                        </div>
                    </div>
                </div>
            </template>
        </vue-clip>

        <a href="#"
           class="Button"
           @click.prevent="resetForm"
           v-show="error"
           style="margin-top: 10px;"
        >
            Upload Another File
        </a>
    </div>
</template>

<script>
    import VueClip from 'vue-clip';

    export default {
        data() {
            return {
                uploading: false,
                error: false,
                errorMessage: '',
                resetting: false
            }
        },

        props: {
            url: {
                required: true,
                type: String,
            },

            method: {
                type: String,
                default: 'POST',
            },

            message: {
                type: String,
                default: 'Drop file or click here to upload'
            },

            successEvent: {
                type: String,
                required: true,
            },

            failEvent: {
                type: String,
                required: true,
            }
        },

        computed: {
            vueClipOptions() {
                return {
                    url: this.url,
                    method: this.method,
                    headers: { 'X-CSRF-TOKEN': Laravel.csrfToken },
                    maxFiles: 1,
                    maxFilesize: 100,
                }
            },

            progressClasses() {
                return {
                    'Dropzone__progress': true,
                    'Dropzone__progress--error': this.error,
                }
            },

            messageClasses() {
                return {
                    'Dropzone__message': true,
                    'Dropzone__message--error': this.error,
                }
            },
        },

        methods: {
            addedFile() {
                this.uploading = true;
            },

            complete(file, status, response) {
                if (status == 'success') {
                    bus.$emit(this.successEvent, response.response);
                } else {
                    this.error = true;
                    this.errorMessage = JSON.parse(response.response).file[0];
                    bus.$emit(this.failEvent);
                }
            },

            resetForm() {
                this.uploading = false;
                this.error = false;
                this.errorMessage = '';
                this.resetting = true;

                _.delay(this.completeReset, 100);
            },

            completeReset() {
                this.resetting = false;
            }
        }
    }
</script>
